import TochiShaderChunk from "./TochiShaderChunk";
import { Vector3 } from "three";

// https://github.com/mrdoob/three.js/issues/4800
export const FresnelChunk: TochiShaderChunk = {
  name: "fresnel",
  uniforms: {
    fresnelBias: { value: 0.0 },
    fresnelScale: { value: 100.0 },
    fresnelPower: { value: 0.0 },
    fresnelOpacity: { value: 1.0 },
    fresnelColor: { value: null },
    fresnelDirection: { value: new Vector3(-0.8, 1, -1) },
    fresnelDirectionIntensity: { value: 1.0 },
    ignoreFresnelDirection: { value: false },
  },
  vertexShader: {
    premain: `
      uniform float fresnelBias;
      uniform float fresnelScale;
      uniform float fresnelPower;
      uniform vec3 fresnelDirection;
      uniform float fresnelDirectionIntensity;
      uniform bool ignoreFresnelDirection;
      varying float vFresnelFactor;
      varying vec3 I;
      varying vec3 N;
      `,
    main: `
      vNormal = normalize( normalMatrix * normal );
      vec3 worldNormal = normalize( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * vNormal );

      #ifdef USE_SKINNING
        I = vec3(modelViewMatrix * vec4(transformed, 1.0));
      #else
        I = (worldPosition).xyz - cameraPosition;
      #endif
      N = normalMatrix * objectNormal;

      // I = I * vec3(100,0,0);

      // float opacity = dot(normalize(N), normalize(-I));
      // opacity = abs(opacity);
      // opacity = 1.0 - pow(opacity, Edge);
      // gl_FragColor = vec4(1.0, 1.0, 1.0, opacity);

      float vFresnelDirectionFactor;
      if (!ignoreFresnelDirection) {
        vFresnelDirectionFactor = dot(normalize(N), fresnelDirection*fresnelDirectionIntensity);
      } else {
        vFresnelDirectionFactor = 1.;
      }
      vFresnelFactor = pow((1.0-dot(normalize(N), normalize(-I))), fresnelPower)*vFresnelDirectionFactor;
      `,
  },
  fragmentShader: {
    premain: `
      uniform float fresnelOpacity;
      uniform vec3 fresnelColor;
      varying float vFresnelFactor;
      `,
    main: `
      gl_FragColor = vec4(mix(gl_FragColor.rgb, fresnelColor, vec3(clamp( vFresnelFactor, 0.0, 1.0 ))*fresnelOpacity), gl_FragColor.a);
      `,
  },
};
